<template>
   <div class="dibu text-c">Copyright(c){{当前年份}} 网站备案号：<a class="c-white" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022027752号</a> 公司：深圳市中浩易汽车租赁有限公司</div>
</template>

<script>
   export default {
      data() {
         return {
            当前年份: new Date().getFullYear(),
         };
      },
      mounted() {
      },
      methods: {
      }
   };
</script>

<style>
</style>